import { IMAGES, MCC_PHOTOS } from "./images";

// Blog posts, managed via the CMS. Drafts are written from MCC-published facts and
// must be approved by MCC before `status` is changed to "published".
export type BlogPost = {
  slug: string;
  title: string;
  category: "Guides" | "Admissions" | "Campus life";
  date: string;
  readMinutes: number;
  excerpt: string;
  image: string;
  status: "draft" | "published";
  body: { heading?: string; text: string }[];
};

export const BLOG_POSTS: BlogPost[] = [
  {
    slug: "what-is-the-ossd",
    title: "What is the OSSD? A plain guide for Nigerian parents",
    category: "Guides",
    date: "Draft",
    readMinutes: 4,
    excerpt: "The Ontario Secondary School Diploma, explained without jargon: what it is, how MCC delivers it in Lagos, and where it can lead.",
    image: MCC_PHOTOS.library,
    status: "draft",
    body: [
      { text: "The Ontario Secondary School Diploma (OSSD) is the high school diploma awarded in Ontario, Canada. At Maple Canadian College, students in Lekki follow the Canadian curriculum and earn the OSSD without leaving Nigeria to begin." },
      { heading: "How it works at MCC", text: "Students take 6 to 8 courses over the University Pathway Program, with 110 hours of instruction per credit. Courses blend real-world content, interactive multimedia and collaborative work, and each student follows an Individual Growth Plan." },
      { heading: "Where it leads", text: "MCC graduates have received offers from universities in Canada, the United States and the United Kingdom, along with significant scholarships. The Admissions team can talk you through the pathway for your child." },
    ],
  },
  {
    slug: "september-or-january-intake",
    title: "September or January: choosing the right intake",
    category: "Admissions",
    date: "Draft",
    readMinutes: 3,
    excerpt: "MCC admits students twice a year. Here is how to decide which start date suits your child.",
    image: IMAGES.campus,
    status: "draft",
    body: [
      { text: "MCC runs two intakes each year: September, aligned with Semester 1, and January, aligned with Semester 2." },
      { heading: "How long will it take?", text: "Programme length depends on entry grade: around 30 months from Grade 10, 20 months from Grade 11 and 10 months from Grade 12." },
      { heading: "Need it faster?", text: "Students who are ready for an intensive pace may be eligible for the Fast Track Programme, which condenses Grade 12 into five months. Admissions confirms eligibility after reviewing transcripts and the placement test." },
    ],
  },
  {
    slug: "inside-the-inexorables-lounge",
    title: "Inside the student lounge: where the Class of 2021 left its mark",
    category: "Campus life",
    date: "Draft",
    readMinutes: 2,
    excerpt: "Handprints, chess boards and a mural signed by ‘The Inexorables’. A small room that says a lot about MCC.",
    image: MCC_PHOTOS.inexorablesLounge,
    status: "draft",
    body: [
      { text: "On one wall of the MCC student lounge, a graduating class painted its name, The Inexorables, surrounded by the handprints of every student in the group." },
      { text: "Today the room is where students play chess, catch up between classes and unwind, a reminder that the people who came before them started in the same place." },
    ],
  },
];
